import cache from 'lscache';
import TagManager from 'react-gtm-module';

import { type Locale } from '../store/i18nSlice';
import { languageStorageKey, sessionIdentifierKey, storeStorageKey } from '../components/auth/constants';
import { minutesToMidnight } from './utils';
import { getTagManagerArgs } from './GTM/googleTagManagerArgs';
import { type GetTagManagerArgs } from './GTM/googleTagManager.type';
import { persistor } from '../store/store';

const analyticsTracking = (event: GetTagManagerArgs['event'], params: GetTagManagerArgs['params']) => {
  TagManager.dataLayer(
    getTagManagerArgs({
      event,
      params,
    })
  );
};

export const cleanBeforeReload = async (newLanguage: Locale | null, newStore: number | null, redirectUrl?: string | null) => {
  const storedLanguages = JSON.parse(cache.get(languageStorageKey));
  const storedStore = cache.get(storeStorageKey);
  const sessionIdentifier = cache.get(sessionIdentifierKey);
  while (Object.keys(localStorage).some(storageKey => storageKey.includes('lscache'))) {
    cache.flush();
  }
  cache.set(sessionIdentifierKey, sessionIdentifier, minutesToMidnight());
  cache.set(languageStorageKey, newLanguage ? JSON.stringify(newLanguage) : JSON.stringify(storedLanguages));
  cache.set(storeStorageKey, newStore || storedStore);

  if (newStore) {
    analyticsTracking('store_change', {
      storeIDbeforeChange: storedStore,
      storeIDafterChange: newStore,
    });

    await persistor.purge();

    if (redirectUrl) {
      globalThis.location.replace(redirectUrl);
    } else {
      globalThis.location.replace('/');
    }
  }

  if (newLanguage) {
    analyticsTracking('language_change', {
      languageBeforeChange: storedLanguages,
      languageAfterChange: newLanguage,
    });

    globalThis.location.reload();
  }
};
